import { ListUsersQuery } from '@akin-home/amplify';
import { deleteUserMutation } from '@akin-home/users/frontend';
import { InfiniteData, useMutation, useQueryClient } from 'react-query';
import { userQueryKeys } from '.';

type CachedUsers = NonNullable<ListUsersQuery['listUsers']>['items'];

/** Handles the serverside deleting of users */
export const useDeleteUserMutation = () => {
  const queryClient = useQueryClient();

  return useMutation((id: string) => deleteUserMutation({ input: { id } }), {
    onSuccess: (_, userID) => {
      queryClient.removeQueries(userQueryKeys.detail(userID));

      queryClient.setQueriesData<CachedUsers | undefined>(
        userQueryKeys.lists(),
        (users) => users?.filter((h: any) => h.id !== userID)
      );

      queryClient.setQueriesData<InfiniteData<ListUsersQuery> | undefined>(
        userQueryKeys.all_pages(),
        (data) => ({
          ...data,
          pageParams: data?.pageParams as string[],
          pages: data
            ? data.pages.map((page) => ({
                ...page,
                listUsers: {
                  ...page.listUsers,
                  items:
                    page.listUsers?.items.filter((u) => u?.id !== userID) || [],
                  __typename: 'ModelUserConnection',
                },
              }))
            : [],
        })
      );
    },
  });
};

export const useDeleteUser = () => {
  const del = useDeleteUserMutation();
  return (id: string) => del.mutateAsync(id);
};
